import { API } from '@/src/api/api'
import { queryKeys } from '@/src/api/queryKeys'
import { ONE_MINUTE_IN_MS } from '@/src/utils/constants'
import { useQuery } from '@tanstack/react-query'

export const useProfilePicture = () => {
  return useQuery({
    queryKey: queryKeys.profilePicture.toKey(),
    staleTime: ONE_MINUTE_IN_MS * 5,
    retry: (failureCount, error: any) => {
      if (error?.status === 404 || error?.response?.status === 404) return false
      return failureCount < 3
    },
    queryFn: async () => {
      const blob = await API.users.getProfilePicture()
      return blob ? URL.createObjectURL(blob) : ''
    },
  })
}
